export default function DealerTactics() {
  const tactics = [
    {
      icon: 'ri-ghost-line',
      title: 'The Phantom Vehicle',
      description: 'That amazing deal you saw online? It sold this morning. But hey, they have this other one that\'s only $4,000 more — and it\'s basically the same thing.',
      reality: 'Always confirm availability before making the trip. If it\'s gone, ask for a written alternative.',
    },
    {
      icon: 'ri-time-line',
      title: 'The Finance Office Add-Ons',
      description: 'You agreed on a price. Now you\'re in a small room being pitched warranties, gap insurance, paint protection, and a fabric guard that costs $400 and is essentially a can of Scotchgard.',
      reality: 'Every add-on is optional. Ask for an itemized list and take time to decide — none of it expires overnight.',
    },
    {
      icon: 'ri-bubble-chart-line',
      title: 'The Nitrogen Tire Upgrade',
      description: 'Your tires will be filled with nitrogen — a gas that makes up 78% of the air you breathe for free every day — and you\'ll be charged $299 for the privilege.',
      reality: 'Regular air works just fine. This one\'s easy to decline.',
    },
    {
      icon: 'ri-grid-line',
      title: 'The Four-Square Worksheet',
      description: 'Trade-in value, monthly payment, purchase price, and down payment all crammed into one box. It makes it genuinely difficult to track whether each number is moving in your favor.',
      reality: 'Negotiate one number at a time. Start with the out-the-door price, then discuss trade-in separately.',
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'The Expiring Deal',
      description: '"This price is only good until 5pm today." In most cases, the same vehicle at the same price is available tomorrow. Urgency is a sales tool — not a policy.',
      reality: 'Take the time you need. A good deal doesn\'t evaporate overnight.',
    },
    {
      icon: 'ri-exchange-dollar-line',
      title: 'The Trade-In Offset',
      description: 'Your car is worth $12,000. They offer $8,500. You negotiate the purchase price down $500, feeling like a win. The trade-in gap quietly absorbed the savings.',
      reality: 'Get an independent trade-in quote first (CarMax, KBB Instant Cash Offer) so you have a baseline.',
    },
  ];

  return (
    <section id="dealer-tactics" className="py-20 bg-slate-900 text-white rounded-2xl my-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/40 rounded-full px-4 py-2 mb-4">
            <i className="ri-spy-line text-amber-400"></i>
            <span className="text-sm font-semibold text-amber-300 uppercase tracking-wide">Buyer Education</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Know Before You Go</h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            These are common industry practices with well-known names.
            Understanding them ahead of time puts you in a much stronger position —
            whether you buy through us or anywhere else.{' '}
            <span className="text-amber-300 italic">We'd rather you be informed than surprised.</span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tactics.map((tactic, idx) => (
            <div
              key={idx}
              className="bg-slate-800 border border-slate-700 rounded-xl p-6 hover:border-amber-500/50 transition-all"
            >
              <div className="w-12 h-12 bg-amber-500/20 rounded-lg flex items-center justify-center mb-4">
                <i className={`${tactic.icon} text-2xl text-amber-400`}></i>
              </div>
              <h3 className="text-xl font-bold mb-2">{tactic.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed mb-3">
                {tactic.description}
              </p>
              <div className="pt-3 border-t border-slate-700">
                <p className="text-amber-400 text-sm font-semibold italic">
                  💡 {tactic.reality}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-teal-500/10 border border-teal-500/30 rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-3 text-teal-400">How We Do It Differently</h3>
          <p className="text-slate-300 text-lg leading-relaxed max-w-3xl mx-auto">
            We don't use any of these approaches — not because we're above them, but because our model doesn't require them.
            We work for <em>you</em>, so our job is to get you the best deal, full stop.
            One flat fee, everything disclosed upfront, no back-and-forth.{' '}
            <span className="text-teal-300 font-semibold">Turns out, transparency is a pretty solid business model.</span>
          </p>
        </div>
      </div>
    </section>
  );
}